module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Stark, Luc Sante\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Richard Stark")]), _vm._v(" was one of the many pseudonyms of Donald E. Westlake (1933-2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ER0xz/tc-custom/9780226772929.jpg?1722573930496",
      "alt": "This image is the cover for the book Rare Coin Score, The Parker Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rare Coin Score, The Parker Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When it comes to heists, Parker believes in some cardinal rules. On this job, he breaks two of them: never bring a dame along—especially not one you like—and never, ever, work with amateurs. Nevertheless, with the help of a creepy coin collector named Billy, and the lure of a classy widow, he agrees to set up a heist of a coin convention. But Billy’s a rookie with no idea how to pull off a score, and the lady soon becomes a major distraction. "), _c('i', [_vm._v("The Rare Coin Score")]), _vm._v(" marks the first appearance of Claire, who pulls off her own heist on Parker's heart—while together they steal two million dollars worth of coins.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0